import React from "react";
import NoticeIcon from "@funds/pages/MyFunds/pages/StakingPage/parts/StakeForm/danger.svg";
import Notice from "@funds/pages/MyFunds/pages/StakingPage/parts/shared/Notice";
import { TradingInfoNoticeProps } from "./ITradingInfoNotice";

const noticeText: { [key: string]: string } = {
  btc: "Bitcoin (BTC) is a highly volatile asset, subject to rapid price changes. The value of your BTC holdings can fluctuate significantly, and there is a risk of partial or total loss. Please ensure you understand the risks involved before trading.",
  eth: "Ethereum (ETH) powers a decentralized network, and its value is driven by market demand, project developments, and broader cryptocurrency trends. The price of ETH can be highly volatile, and trading may result in significant gains or losses.",
  bfusd:
    "Tether (USDT) is a stablecoin pegged to the value of fiat currency, but it is not without risks. Fluctuations in market demand, regulatory scrutiny, and issues related to its reserves can affect its stability. Trade USDT with caution, keeping these risks in mind.",
};

const TradingInfoNotice = ({ currency }: TradingInfoNoticeProps) => {
  if (!currency) {
    return (
      <Notice
        message="Trading of Virtual Assets"
        icon={<NoticeIcon />}
        description="All trading services in Virtual Assets on the BF Platform, which consists in BTC, ETH and USDT trades are solely operated by the Virtual Assets Broker. The BF Platform Operator does not provide any custody or trading service in relation to Virtual Assets."
        type="warning"
        showIcon
        style={{ margin: "0 auto 20px" }}
      />
    );
  }

  if (noticeText[currency]) {
    return (
      <Notice
        icon={<NoticeIcon />}
        description={noticeText[currency]}
        type="warning"
        showIcon
        style={{ margin: "0 auto 20px" }}
      />
    );
  }

  return null;
};

export default TradingInfoNotice;
